import { Box, Button } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import Pricing from "@pathwright/features/src/modules/pricing/PricingAdapter"
import { spaceAugmentationDrawerIdentityHideCss } from "@pathwright/features/src/modules/space/augmentation/SpaceAugmentationDrawer"
import { ConnectStores } from "lib/core/store"
import PricingBack from "./PricingBack"
import "./PricingContainer.css"
import PricingCoreOverlay from "./overlay/PricingCoreOverlay"

const PricingContainer = (props) => {
  const { current_step, selected_plan, match } = props

  if (!selected_plan) return null

  return (
    <Box
      className="PricingContainer"
      // Hide space augmentation in pricing page. The identity obscures the Back button.
      css={spaceAugmentationDrawerIdentityHideCss}
    >
      {current_step === "plan" && (
        <div className="PricingLinks">
          <PricingBack />
          <Button
            colorPalette="gray"
            variant="ghost"
            onClick={() => {
              const dest = document.querySelector("#pricing-faq")
              if (!dest) return

              const offset = 200
              window.scrollTo({
                top: dest.offsetTop - offset,
                behavior: "smooth"
              })
            }}
            className="PricingInfo"
          >
            <Pathicon icon="info-circle" />
            Pricing FAQs
          </Button>
        </div>
      )}
      <Pricing
        context="space"
        stripeApiKey={
          window.App.getStore("pathwrightAccount").getState().payment_key
        }
        schoolId={App.getStore("school").getState().school.id}
      />
      {match.params.billingStep === "core" && <PricingCoreOverlay {...props} />}
    </Box>
  )
}

PricingContainer.displayName = "PricingContainer"

const mapStateToProps = (state, ownProps) => {
  const { selected_plan, current_step } = state.billingStore.state
  return _.assign(
    {
      selected_plan,
      current_step
    },
    ownProps
  )
}

const stores = [
  {
    store: "navigation"
  },
  {
    store: "billing",
    watch: [
      "selected_plan",
      "learner_count",
      "billing_interval",
      "current_step"
    ]
  }
]

export default ConnectStores(PricingContainer, stores, {}, mapStateToProps)
